'use client';

import { c as _c } from "react/compiler-runtime";
import { useVaultRoute } from '@/components/VaultPage/components/VaultRoute';
import { VaultYourPositionLoading } from '@/components/VaultPage/VaultV1/VaultYourPosition/states';
import VaultV2YourPositionClient from '../VaultV2YourPosition.client';

/**
 * The page renders the position client without a fallback, so the route loader renders it
 * too, in its own loading state, for the resolved vault.
 */
const VaultV2YourPositionRouteLoading = () => {
  const $ = _c(2);
  const route = useVaultRoute();
  let t0;
  if ($[0] !== route) {
    t0 = route ? <VaultV2YourPositionClient chainId={route.chainId} vaultAddress={route.address} /> : <VaultYourPositionLoading />;
    $[0] = route;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default VaultV2YourPositionRouteLoading;